import { render, staticRenderFns } from "./userSub.vue?vue&type=template&id=185b88ff&scoped=true&"
import script from "./userSub.vue?vue&type=script&lang=js&"
export * from "./userSub.vue?vue&type=script&lang=js&"
import style0 from "./userSub.vue?vue&type=style&index=0&id=185b88ff&prod&scoped=true&lang=css&"
import style1 from "./userSub.vue?vue&type=style&index=1&id=185b88ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185b88ff",
  null
  
)

export default component.exports